import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initializeSentry, Sentry } from './observability/sentry';

initializeSentry();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={
        <main role="alert" style={{ padding: "2rem", textAlign: "center" }}>
          Something went wrong. Please refresh the page or try again shortly.
        </main>
      }
    >
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
